// extracted by mini-css-extract-plugin
module.exports = {"GraphicText":"GraphicTextZero_GraphicText__V86cS"};